module.exports = __webpack_public_path__ + "img/panelView_defaultBG_special.83c12b98.png";